import {memo} from "react";
import {Card, CardBody, Typography} from "@material-tailwind/react";
const FormSkeleton = () => {

    return <>
        <div className="grid grid-cols-2 mt-4 items-center animate-pulse">
            <div className="animate-pulse">
                <Typography
                    as="h2"
                    variant="paragraph"
                    className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800 text-4xl"
                >
                    &nbsp;
                </Typography>
            </div>
        </div>
        <Card className="mt-12 bg-white dark:bg-blue-gray-900 dark:text-gray-500">
            <CardBody className="overflow-scroll px-0 animate-pulse">
                <div className="max-w-md">
                    <Typography
                        as="div"
                        variant="paragraph"
                        className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
                    >
                        &nbsp;
                    </Typography>
                    <Typography
                        as="div"
                        variant="paragraph"
                        className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
                    >
                        &nbsp;
                    </Typography>
                    <Typography
                        as="div"
                        variant="paragraph"
                        className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
                    >
                        &nbsp;
                    </Typography>
                    <Typography
                        as="div"
                        variant="paragraph"
                        className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
                    >
                        &nbsp;
                    </Typography>
                    <Typography
                        as="div"
                        variant="paragraph"
                        className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
                    >
                        &nbsp;
                    </Typography>
                    <Typography
                        as="div"
                        variant="paragraph"
                        className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
                    >
                        &nbsp;
                    </Typography>
                    <Typography
                        as="div"
                        variant="paragraph"
                        className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
                    >
                        &nbsp;
                    </Typography>
                </div>
            </CardBody>
        </Card>
    </>
}

export default memo(FormSkeleton);
